/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ location: NonNullable<unknown> }} Toast_Moved_AudioInputs */

const en_toast_moved_audio = /** @type {(inputs: Toast_Moved_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved audio to ${i?.location}`)
};

const es_toast_moved_audio = /** @type {(inputs: Toast_Moved_AudioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio movido a ${i?.location}`)
};

/**
* | output |
* | --- |
* | "Moved audio to {location}" |
*
* @param {Toast_Moved_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_moved_audio = /** @type {((inputs: Toast_Moved_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Moved_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_moved_audio(inputs)
	return en_toast_moved_audio(inputs)
});